import type { RootState } from 'redux/store';
import { createSelector } from 'reselect';

const selectHeader = (state: RootState) => state.header;

export const selectDefaultSearchId = createSelector(
	selectHeader,
	(header) => header.defaultSearchId,
);

export const selectSelloutCount = createSelector(
	selectHeader,
	(header) => header.selloutCount,
);

export const selectShowAskRev = createSelector(
	selectHeader,
	(header) => header.showAskRev,
);

export const selectEnableSellOutFlag = createSelector(
	selectHeader,
	(header) => header.enableSellOutFlag,
);
